import { Box, Card, Chip, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import "../../scss/pages/Leave/Leave.scss";
import { useNavigate, } from 'react-router';
import { CREAT_LEAVE_PATH } from '../../utils/Constants';
import { useDispatch, useSelector } from 'react-redux';
import { APPLY_LEAVE_HISTORY, LEAVE_DETAILS, SELECTED_CARD_DETAILS } from '../../sagas/type';
import { getLocalStoreString } from '../../utils/Helper';
import NoDataImage from '../../asset/svg/NoDataImage.svg'

var today = new Date();
var currentYear = today.getFullYear();
var getMonth = today.getMonth() + 1;
var currentMonth = getMonth < 9 ? '0' + getMonth : getMonth
const currentMonthYear = currentYear + '-' + currentMonth;

function Leave() {
    const [selectedMonthYear, setSelectedMonthYear] = useState(currentMonthYear);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const EmployeeCode = getLocalStoreString("EmployeeCode");
    const { leaveDetailsData, applyLeaveHistoryData, } = useSelector(mapStateToProps);

    const getDateWeek = (dateString) => {
        const date = new Date(dateString);
        const daysOfWeek = ['Sun', "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const dayOfWeek = daysOfWeek[date.getDay()];
        const dayOfMonth = date.getDate();
        const monthOfYear = monthsOfYear[date.getMonth()];
        const formattedDate = `${dayOfWeek}, ${dayOfMonth} ${monthOfYear}`
        return formattedDate;
    }

    useEffect(() => {
        getLeaveDatas();
    }, [])
    window.addEventListener('employeeDetailsFetch', () => {
        getLeaveDatas();
        getLeaveHistory();
    })

    useEffect(() => {
        getLeaveHistory();
    }, [selectedMonthYear])

    const getLeaveDatas = () => {
        const EmployeeCode = getLocalStoreString("EmployeeCode")
        dispatch({
            type: LEAVE_DETAILS,
            payload: { EmployeeCode },
        });
    }

    const getLeaveHistory = () => {
        const getDateMonth = selectedMonthYear.split('-')
        const EmployeeCode = getLocalStoreString("EmployeeCode")
        dispatch({
            type: APPLY_LEAVE_HISTORY,
            payload: { employeeCode: EmployeeCode, month: getDateMonth[1], year: getDateMonth[0] },
        });
    }

    const navigateToCreateLeave = () => {
        navigate(CREAT_LEAVE_PATH, { state: { leaveDetailsData: leaveDetailsData } })
    }

    const handleMontheChange = (event) => {
        const monthD = event.target.value;
        setSelectedMonthYear(monthD);
    };

    const handleCardClick = (history) => {
        getSelectedCardDatas(history?.applicationId);
    }

    const getSelectedCardDatas = (id) => {
        const EmployeeCode = getLocalStoreString("EmployeeCode")
        dispatch({ type: SELECTED_CARD_DETAILS, payload: { employeeCode: EmployeeCode, applicationId: id, navigate: navigate, leaveDetailsData: leaveDetailsData } });
    }


    return (
        <div className='leaveContainer'>
            <div className='leaveContainer_header'>
                <Typography className='leaveContainer_header_header1'>Leave</Typography>
                <Typography className='leaveContainer_header_applyLeave-link' onClick={navigateToCreateLeave}>Apply Leave</Typography>
            </div>

            <Box >
                <div className='leaveContainer_leaveCardContainer'>
                    {leaveDetailsData && leaveDetailsData.length > 0 && leaveDetailsData.map((data) => {
                        return (
                            <div className='leaveContainer_leaveCardContainer_leaveAnalyticsBox'>
                                <Typography fontStyle='normal' fontWeight='600' fontSize='16px' lineHeight='16px' textAlign='center' color='#FFFFFF'>{data?.balance?.toString().padStart(2, '0')}</Typography>&nbsp;&nbsp;&nbsp;&nbsp;

                                <Typography color='#BFC7D7' fontStyle='normal' fontWeight='500' fontSize='10px' lineHeight='10px' textAlign='center' >{data?.policyName}</Typography>
                            </div>
                        )
                    })
                    }
                </div>
            </Box >

            <div className='leaveContainer_MonthPicker' >
                <input
                    type="month"
                    id="monthPicker"
                    value={selectedMonthYear}
                    onChange={handleMontheChange}
                    className='leaveContainer_MonthPicker_calender'
                />
            </div>

            {applyLeaveHistoryData && applyLeaveHistoryData.length > 0 ? applyLeaveHistoryData.map((history) => {
                return (
                    <div style={{ padding: '0.5rem 0rem' }}>
                        <Card className='leaveContainer_approvalContainer' onClick={() => handleCardClick(history)}>
                            <Grid container style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                                <Grid color='white' fontWeight='500' fontSize='10px' lineHeight='10px' fontStyle='normal' item >{getDateWeek(history.fromDate)}{history.toDate && !(history.fromDate == history.toDate) ? `  -  ${getDateWeek(history.toDate)}` : null}</Grid>
                                <Grid color='white' item >
                                    <Chip label={history.status} color={history.status == 'APPROVED' ? 'success' : history.status == 'PENDING' ? 'warning' : 'error'} variant="outlined" />
                                </Grid>
                            </Grid>
                        </Card>
                    </div>
                )
            }) :
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                    <div className='leaveContainer_emptyImages' style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                        <img className='leaveContainer_noDataImage' style={{ heigth: '54px', width: '68px' }} src={NoDataImage} alt="" />
                    </div>
                    <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                        <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='#FFFFFF' >No Leaves for this month</Typography>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        leaveDetailsData: state.leaveConfig.leaveConfigDetailsData,
        applyLeaveHistoryData: state.leaveConfig.applyLeaveHistoryData,
    }
}

export default Leave